import FileModel             from '@/models/services/file/FileModel';
import React                 from 'react';
import axios                 from 'axios';
import authStore             from '@/stores/authStore';
import { blobToBase64Async } from '@widesk-core/tools/blobTools';

const cacheB64: { [key: string]: string | undefined } = {};

const useFile = (file?: FileModel) => {
	const [error, setError] = React.useState<string | undefined>();
	const [source, setSource] = React.useState<string | undefined>('');
	const [sourceIsLoading, setSourceIsLoading] = React.useState(false);

	const fetchSource = async () => {
		if (file) {
			const downloadPath = file.downloadPath;
			try {
				if (cacheB64[downloadPath]) {
					setSource(cacheB64[downloadPath]);
				} else if (file.isPublic) {
					setSource(downloadPath);
				} else {
					setSourceIsLoading(true);
	
					const response = await axios.get(downloadPath, {
						headers: { 'X-Platform-Authorization': `Bearer ${authStore.token}` },
						responseType: 'blob',
					});
	
					const b64 = await blobToBase64Async(response.data) as string;
	
					cacheB64[downloadPath] = b64;
	
					setSource(b64);
				}
			} catch (error) {
				console.log(error);
				setError(`${error}`);
				throw new Error(`Une erreur s'est produite`);
			} finally {
				setSourceIsLoading(false);
			}
		}
	};

	React.useEffect(() => {
		fetchSource();
	}, [file?.downloadPath]);

	return {
		error,
		source,
		sourceIsLoading,
	};
};

export default useFile;